// Plugins
jQuery.fn.selectText = function () {
    var doc = document;
    var element = this[0];
    var range, selection;
    // console.log(this, element);
    if (doc.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
    } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
    }
};

function adjustMinHeight() {
    if ($('.adjust').length) {
        var headerHeight;
        if ($('header.main').is(':visible')) {
            headerHeight = $('header.main').outerHeight();
        } else {
            headerHeight = 60;
        }
        $('.adjust').css({
            'min-height': $(window).height() - (headerHeight + $('footer.main').outerHeight())
        });
    }
}
adjustMinHeight();

$(window).resize(function () {
    adjustMinHeight();
});

// add the filled class to the labels
$('body').on('focus', '.fields li input, .fields li textarea', function () {
    var $this = $(this);
    $this.keyup(function () {
        if ($this.val() !== '') {
            $this.parent('li').addClass('filled');
            $this.removeClass('error');
        } else {
            $this.parent('li').removeClass('filled');
        }
    });
});

$('body').on('blur', '.fields li input, .fields li textarea', function () {
    var $this = $(this);
    if ($this.val() !== '') {
        $this.parent('li').addClass('filled');
        $this.removeClass('error');
    } else {
        $this.parent('li').removeClass('filled');
    }
});

$('body').on('click', '.button.disabled', function () {
    return false;
});

// open the nav on mobile
$('body').on('click', '.open-nav', function () {
    $('.mobile-main').toggleClass('opened');

    return false;
});

$('body').on('click', '.open-overlay', function () {
    $('.mobile-main').removeClass('opened');
    return false;
});

// MODALS 
function closeModal() {
    if (!$('body').attr('data-force_login') && !$('body').attr('data-registration_closed')) {
        $('.overlay, .modal, .admin-overlay').removeClass('visible');
        $('.notice-overlay, .notice-modal').removeClass('visible');
    }
}

function openModal(modal) {
    var scrollTop = $(window).scrollTop();
    $(modal).css({
        'top': (scrollTop - 500) + 'px'
    });

    setTimeout(function () {
        $(modal).addClass('visible');
        $(modal).find('.fields li input, .fields li textarea').each(function () {
            var $this = $(this);
            if ($this.val() !== '') {
                $this.parent('li').addClass('filled');
            } else {
                $this.parent('li').removeClass('filled');
            }
        });
    }, 100);

    $('.overlay').addClass('visible');
}

var animateDots;
function runDots() {
    var glowing = $('.notice-modal .dots .glowing').length;
    var total = $('.notice-modal .dots span').length;

    if (!glowing) {
        $('.notice-modal .dots span').first().addClass('glowing');
    } else if (glowing === total) {
        $('.notice-modal .dots span').first().removeClass('glowing');
    } else {
        if ($('.notice-modal .dots span:first').hasClass('glowing')) {
            // add glowing to the next class
            $('.notice-modal .dots .glowing').last().next().addClass('glowing');
        } else {
            $('.notice-modal .dots .glowing:first').removeClass('glowing');
        }
    }

    animateDots = setTimeout(runDots, 100);
}
// runDots();

function cancelDots() {
    clearTimeout(animateDots);
}

function showNotice(type, title, message, button) {
    $('.notice-modal').removeClass('success, error');
    $('.dots span').removeClass('glowing');

    switch (type) {
        case 'processing':
            runDots();
            break;

        case 'success':
            $('.notice-modal').addClass('success');
            break;

        case 'error':
            $('.notice-modal').addClass('error');
            break;
    }

    $('.notice-modal h3').html(title);

    if (message) {
        $('.notice-modal p').show().html(message);
    } else {
        $('.notice-modal p').hide();
    }

    if (button) {
        $('.notice-modal .buttons').show();
        $('.notice-modal .button').html(button);
    } else {
        $('.notice-modal .buttons').hide();
    }

    $('.notice-overlay, .notice-modal').addClass('visible');
}

$('body').click(function (e) {
    if ($(e.target).attr('class') === 'overlay visible' || $(e.target).attr('class') === 'admin-overlay visible') {
        closeModal();
    }
});

$(document).keyup(function (e) {
    if (e.keyCode === 27) { // Esc
        closeModal();
    }
});

$('body').on('click', '.modal a.close', function () {
    closeModal();
    return false;
});

$('body').on('click', '.notice-modal a.close', function () {
    cancelDots();
    $('.notice-overlay, .notice-modal').removeClass('visible');

    return false;
});

// mask
$('.mask').each(function () {
    var $this = $(this);
    $this.mask($this.attr('data-mask'), {
        placeholder: $this.attr('data-placeholder')
    });
});